import debounce from 'lodash.debounce';

export function setAppHeight() {
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
}

window.addEventListener('resize', debounce(setAppHeight, 400));
